"use client";

import SearchAccordion from "@/components/search-accordion";
import { Input } from "@/components/ui/input";
import { useTranslations } from "next-intl";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState, useTransition } from "react";
import AppButton from "@/components/app-button";

export function Search() {
  const t = useTranslations();
  const [isPending, startTransition] = useTransition();
  const [searchCondition, setSearchCondition] = useState("");

  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const searchCondition = searchParams.get("search_condition");

    searchCondition && setSearchCondition(searchCondition);
  }, []);

  const handleSearch = () => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set("page", "1");
    searchParams.set("search_condition", searchCondition);
    router.push(`${pathname}?${searchParams}`);
  };

  return (
    <SearchAccordion>
      <div className="space-y-1">
        <span className="capitalize">{t("action.search")}</span>
        <Input
          autoComplete="off"
          placeholder={t("component-title.input-search")}
          className="focus-ring-subtle"
          value={searchCondition}
          onChange={(event) => setSearchCondition(event.target.value)}
        />
      </div>

      <AppButton
        variant="search"
        onClick={() => startTransition(() => handleSearch())}
        disabled={isPending}
      >
        {t("action.search")}
      </AppButton>
    </SearchAccordion>
  );
}
